"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwitchGroupMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _LabeledControl = require("../../components/LabeledControl/LabeledControl.styles");
/** @class SwitchGroupMixin */
/** @method */
var SwitchGroupMixin = (0, _styledToken.default)({
  borderColor: 'SwitchGroup.borderColor',
  borderWidth: 'SwitchGroup.borderWidth'
}, function (_ref) {
  var borderColor = _ref.borderColor,
    _ref$borderWidth = _ref.borderWidth,
    borderWidth = _ref$borderWidth === void 0 ? 1 : _ref$borderWidth;
  return (0, _styledComponents.css)(["> ", "{border-top:", "px solid ", ";&:last-child{border-bottom:", "px solid ", ";}}"], _LabeledControl.StyledLabeledControl, borderWidth, borderColor, borderWidth, borderColor);
});
exports.SwitchGroupMixin = SwitchGroupMixin;